<!-- <li class="nav-item nav-profile">
  <a class="nav-link">
    <div class="nav-profile-image">
      <img src="assets/images/users.png" alt="profile">
      <span class="login-status online"></span>
    </div>
    <div class="nav-profile-text d-flex flex-column">
      <span class="font-weight-bold mb-2">{{admin_data.province}}</span>
      <span class="text-secondary text-small">ฝ่ายการเงินและบัญชี</span>
    </div>
    <i class="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
  </a>
</li> -->
<li class="nav-item" id="dashboard">
  <a class="nav-link " (click)="onClick()" [routerLink]="['/dashboard']">
    <span class="menu-title">หน้าหลัก</span>
    <i class="mdi mdi-home menu-icon"></i>
  </a>
</li>
<li class="nav-item" id="auditorreport">
  <a class="nav-link" (click)="onClick()" [routerLink]="['/auditorreport/auditorreport']">
    <span class="menu-title">รายงานผู้สอบบัญชี</span>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
</li>
<li class="nav-item" id="performancesummary">
  <a class="nav-link" (click)="onClick()" [routerLink]="['/performancesummary']">
    <span class="menu-title">สรุปผลการดำเนินงาน</span>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
</li>
<li class="nav-item" id="financialstatus">
  <a class="nav-link" (click)="onClick()" [routerLink]="['/report/financialstatus']">
    <span class="menu-title">รายงานสถานะทางการเงิน</span>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
</li>
<li class="nav-item" id="finances">
  <a class="nav-link" data-toggle="collapse" href="#finance" aria-expanded="false" aria-controls="page-layouts">
    <span class="menu-title">งบการเงิน</span>
    <i class="menu-arrow"></i>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
  <div class="collapse" id="finance">
    <ul class="nav flex-column sub-menu">
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/plan/trialbalance']"
          id="trialbalance">งบทดลอง</a></li>
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/auditorreport/finencialposition']"
          id="finencialposition">งบแสดงฐานะการเงิน</a></li>
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/auditorreport/operatingresults']"
          id="operatingresults">งบแสดงผลการดำเนินงาน</a></li>
    </ul>
  </div>
</li>
<li class="nav-item" id="plans">
  <a class="nav-link" data-toggle="collapse" href="#plan" aria-expanded="false" aria-controls="page-layouts">
    <span class="menu-title">แผน</span>
    <i class="menu-arrow"></i>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
  <div class="collapse" id="plan">
    <ul class="nav flex-column sub-menu">
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/plan/plan_result']"
          id="plan_result">แผน-ผล</a>
      </li>
      <li class="nav-item"> <a id="compare" (click)="onClick()" class="nav-link"
          [routerLink]="['/plan/compare']">เปรียบเทียบแผน-ผล</a></li>
    </ul>
  </div>
</li>
<!-- <li class="nav-item" id="historicaldata">
  <a class="nav-link" (click)="onClick()" [routerLink]="['/historicaldata']">
    <span class="menu-title">ข้อมูลย้อนหลัง</span>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
</li> -->
<li class="nav-item" id="historicaldata">
  <a class="nav-link" data-toggle="collapse" href="#history" aria-expanded="false" aria-controls="page-layouts">
    <span class="menu-title">ข้อมูลย้อนหลัง</span>
    <i class="menu-arrow"></i>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
  <div class="collapse" id="history">
    <ul class="nav flex-column sub-menu">
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/historical/trialbalance']"
          id="h_trialbalance">งบทดลอง</a></li>
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/historical/cashflow']"
          id="h_cashflow">Cash Flow</a></li>
    </ul>
  </div>
</li>
<li class="nav-item" id="receivables">
  <a class="nav-link" data-toggle="collapse" href="#receivable" aria-expanded="false" aria-controls="page-layouts">
    <span class="menu-title">ข้อมูลโครงการ</span>
    <i class="menu-arrow"></i>
    <i class="mdi mdi-account-multiple menu-icon"></i>
  </a>
  <div class="collapse" id="receivable">
    <ul class="nav flex-column sub-menu">
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/receivables/revenue_estimated']"
          id="revenue_estimated">ประมาณการรายรับ</a></li>
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/receivables/revenue_payaccount']"
          id="revenue_payaccount">บัญชีการรับ-จ่ายเงินโครงการ</a></li>
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/receivables/control']"
          id="control">ทะเบียนคุมโครงการ</a></li>
      <li class="nav-item"> <a (click)="onClick()" class="nav-link" [routerLink]="['/receivables/summary']"
          id="summary">สรุปเงินโครงการ</a></li>
    </ul>
  </div>
</li>
<li class="nav-item" id="accurateinterest">
  <a (click)="onClick()" class="nav-link" [routerLink]="['/calculate/accurateinterest']">
    <span class="menu-title">การคำนวณดอกเบี้ยเงินกู้<br>แบบละเอียด / ค่าปรับ</span>
    <i class="mdi mdi-calculator menu-icon"></i>
  </a>
</li>
<li class="nav-item" id="calconditions">
  <a (click)="onClick()" class="nav-link" [routerLink]="['/calconditions']">
    <span class="menu-title">เงื่อนไขการคำนวณดอกเบี้ย</span>
    <i class="mdi mdi-book-variant menu-icon"></i>
  </a>
</li>
<li class="nav-item" id="auditbyInternal">
  <a (click)="onClick()" class="nav-link" [routerLink]="['/auditbyInternal']">
    <span class="menu-title">รายงานการตรวจสอบโดย<br>กลุ่มตรวจสอบภายใน</span>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
</li>
<!-- <li class="nav-item" id="notfinancial">
  <a (click)="onClick()" class="nav-link" [routerLink]="['/notfinancial']">
    <span class="menu-title">รายงานไม่ใช่การเงิน</span>
    <i class="mdi mdi-file-document menu-icon"></i>
  </a>
</li> -->
<div class="text-center" style="margin-top: 50px;">
  <div class="text-center" style="margin-right: 3px;">จำนวนผู้เข้าชมเว็บไซต์</div>
  <div class="text-center">
    <span class="count-visitor" *ngFor="let i of visitor">{{i}}</span>
  </div>
</div>